import { GetServerSideProps, NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { Fragment } from 'react';

import { SpeakersContent } from '@/components/ui/features/speakers/SpeakersContent/SpeakersContent';
import { SpeakersSearchInput } from '@/components/ui/features/speakers/SpeakersSearchInput/SpeakersSearchInput';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { AccessFrom } from '@/enums/AccessFrom';
import { querySelectedSpeakersFilterEvent } from '@/queries/algolia-filter-item';
import { generateStore } from '@/utils/generateStore';
import { Hydrate, IHydrateProps } from '@/utils/swr/Hydrate';
import { StringParam, urlQueryStringValidate } from '@/utils/url-query-string';

const Speakers: NextPage<IHydrateProps> = ({ fallback }) => {
  return (
    <Fragment>
      <NextSeo title="Conference Speakers" />
      <Hydrate fallback={fallback}>
        <Layout accessFrom={AccessFrom.Core} navigationVariant="default">
          <SpeakersSearchInput />
          <SpeakersContent />
        </Layout>
      </Hydrate>
    </Fragment>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const store = generateStore({ context });
  const { event_id, query } = urlQueryStringValidate<{
    query: string;
    event_id: string;
  }>(context.query, {
    query: StringParam,
    event_id: StringParam,
  });

  // ThinProfile infinite query is now handled client-side via tanstack

  if (event_id) {
    await store.fetchResource(
      querySelectedSpeakersFilterEvent({
        event_id,
        query,
        selected_resource: 'event',
        selected_id: event_id,
      })
    );
  }

  return {
    props: {
      fallback: store.fallback,
    },
  };
};

export default Speakers;
